import clsx from "classnames";
import { Col, Container, Row } from "react-bootstrap";
import { Description, Image, Title } from "@/ui";
import classes from "./styles.module.scss";

export const Benefits = ({ className, title, description, bgColor, titleColor, textColor, items }) => {
  return (
    <div className={clsx(className, classes.benefits, `bg-${bgColor}`)}>
      <Container>
        <Title title={title} data-sourceflow-prop="title" className={clsx("mb-2", `text-${titleColor}`)} />
        <Description
          description={description}
          data-sourceflow-prop="description"
          className={clsx("mb-5", `text-${textColor}`)}
        />
        <Row className="mt-5">
          {items?.map((i, k) => (
            <Col key={k} xs={12} md={4} className="mb-4">
              <div className={classes.benefits__item}>
                {i.icon?.url && <Image img={{ src: i.icon.url }} size="50x50" alt="" data-sourceflow-prop="items" />}
                <div>
                  <Title
                    title={i.title}
                    tag="h3"
                    className={clsx("h5 mb-0", `text-${i.titleColor}`)}
                    data-sourceflow-prop="items"
                  />
                  <Description
                    description={i.text}
                    data-sourceflow-prop="items"
                    className={clsx(`text-${i.textColor}`)}
                  />
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default Benefits;
